import { useState, useEffect, useCallback, useRef } from "react";
import api from "@/lib/api";

export default function useGenerations() {
  const [generations, setGenerations] = useState([]);
  const [loading, setLoading] = useState(true);
  const timer = useRef(null);

  const fetchAll = useCallback(async () => {
    try {
      const { data } = await api.get("/generations");
      setGenerations(data);
      return data;
    } catch {
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  useEffect(() => {
    const anyProcessing = generations.some((g) => g.status === "processing");
    if (anyProcessing) {
      timer.current = setTimeout(fetchAll, 3000);
    }
    return () => clearTimeout(timer.current);
  }, [generations, fetchAll]);

  return { generations, loading, refetch: fetchAll, setGenerations };
}
